import React from 'react'
import Layout from '../../components/Layout'
import BlogRoll from '../../components/BlogRoll'

export default class BlogIndexPage extends React.Component {

    render() {
        return (
            <Layout>
                <section className="section">
                    <div className="container">

                        <div className="content">
                            <div className="has-text-centered">
                                <h3 style={{ color : "#b3722d" }} >Nos réalisations : </h3>
                            </div>

                            <div className="content is-offset-1" style={{marginTop: '2rem'}}>
                                <p></p>
                                <div>
                                </div>
                                <BlogRoll />
                            </div>
                        </div>
                    </div>
                </section>
            </Layout >
        )
    }
}
